import React from 'react'
import { Input, Grid, Typography } from '@mui/material';

function OtherInput(props) {
    const newName = props.name + "_others"
    if (props.value.value === "Others" || props.value.value === "其他") {
        return (
            <Grid container mt={7} mb={7} ml="auto" mr="auto" maxWidth="900px" display="flex" justifyContent="center">
                <Typography>If there are others, please specify:</Typography>
                <Input
                    name={newName}
                    value={props.otherValue}
                    onChange={e => {
                        props.setState({
                            ...props.state,
                            [newName]: e.target.value
                        })
                    }}
                    inputProps={{ style: { textAlign: 'center', marginTop: '16px' } }}
                    fullWidth={true}
                    placeholder="Others"
                    autoFocus
                />
            </Grid>
        )
    }
    else if (Array.isArray(props.value)) {
        if (props.value.some(item => item.value === 'Others') || props.value.some(item => item.value === '其他')) {
            return (
                <Grid container mt={7} mb={7} ml="auto" mr="auto" maxWidth="900px" display="flex" justifyContent="center">
                    <Typography>{props.description} </Typography>
                    <Input
                        name={newName}
                        value={props.otherValue}
                        onChange={e => {
                            props.setState({
                                ...props.state,
                                [newName]: e.target.value
                            })
                        }}
                        inputProps={{ style: { textAlign: 'center', marginTop: '16px' } }}
                        fullWidth={true}
                        placeholder="Others"
                        autoFocus
                    />
                </Grid>
            )
        } else {
            return <div></div>
        }
    } else {
        return <div></div>
    }
}

export default OtherInput